<template>
    <v-text-field
        v-model="cuit"
        :rules="obligatorioNumerico"
        label="Cuit actual del profesional"
        required
        variant="solo"
    ></v-text-field>
    <v-btn
        :disabled="!cuit"
        id="boton-verde"
        :loading="cargando"
        @click="buscarProfesional"
        class="mb-5"
    >
        Buscar profesional
    </v-btn>
    <CrearProfesionalForm
        v-if="profesional"
        :key="profesional.id"
        :profesionalExistente="profesional"
        :edicion="true"
    ></CrearProfesionalForm>
</template>
<style src="../assets/general.css"></style>
<script>
    import { obligatorioNumerico } from '@/_helpers/rules';
    import ProfesionalService from '@/api/ProfesionalService';
    import CrearProfesionalForm from './CrearProfesionalForm.vue';
    import { OpcionesBusquedaProfesional } from '@/interfaces/adminInterfaces';

    const profesionalService = new ProfesionalService();

    export default {
        components: {
            CrearProfesionalForm
        },
        data() {
            return {
                cuit: '',
                cargando: false,
                alert: false,
                alertType: '',
                mensaje: '',
                alertKey: 0
            }
        },
        methods: {
            async buscarProfesional(){
                this.cargando = true;
                const responseProfesional = await profesionalService.getProfesional(this.cuit);
                if(responseProfesional && responseProfesional.status == 200){
                    this.profesional = responseProfesional.data;
                } else {
                    this.alertType = 'error';
                    this.mensaje = 'No se encontró un profesional con el cuit ingresado';
                }
                this.alert = true;
                this.alertKey++;
                this.cargando = false;
            }
        }
    }
</script>